/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// $('[data-action="add-to-cart"]').on('click', function() {
//         $.post("/cart/add.js", {
//             id: 39357676650648,
//           "properties": {
//               "delivery_time": "7-8 days",
//             },
          
//         }, function(response) {
//            console.log('our response', response);
//         });

//         return false;
//     });

/// gtm ///
$(function() {
  $("#shopify-section-header").on("click", "a.tmenu_item_link", function(e) {
    //console.log(e.target.classList);
    if ($(e.target).hasClass("tmenu_item_link")) {
      var eventName = encodeURIComponent($(e.target).find(".tmenu_item_text").text().trim().toLowerCase().replace(" ", "_")) + "_click";
      dataLayer.push({'event': eventName});
    }
  });
});

/// custom sidebar sticky/scroll ///
function filterSidebarPositioning() {
  var windowWidth = $(window).width();
  var windowHeight = $(window).height();
  var $el = $("#js-filter-card");
  if (windowWidth >= 1000 && windowHeight >= 600) {
    var headerHeight = $("#shopify-section-announcement-bar").height() + $("#shopify-section-header").height();
    var margin = 30;
    var elementHeight = windowHeight - headerHeight - (2 * margin);
    var elementTop = headerHeight + margin;
    console.log("filterSidebarPositioning", windowHeight, windowWidth, headerHeight, margin, elementHeight);  
    $el.css({"position":"sticky","overflow":"scroll","top": elementTop + "px", "height": elementHeight + "px"});
  } else {
    $el.css({"position":"","overflow":"","top":"","height":""});
  }
}
$(function() {
  filterSidebarPositioning();
  $(window).on("resize orientationchange", filterSidebarPositioning);
});

$('[data-action="add-to-cart"]').click(function( ){
  
  	var cnewVarient_Id	= $('form[action="/cart/add"]').find('[name="id"]').val();
  	//var shipping_days = $('#days_count').html();
  	var shipping_days = $('.product_delivery_time.active .custom-shipping-time span').html();
  	
  	var addedQuanitity = $('input[name="quantity"]').val();
  	 
  
  	cnewVarient_Id = parseInt(cnewVarient_Id);
  
  	//console.log('cnewVarient_Id', cnewVarient_Id);
  
    //console.log('addedQuanitity', addedQuanitity);
  
    addItemToCart(cnewVarient_Id, shipping_days, addedQuanitity);
  
  	return false;
   
  });

  function addItemToCart(cvariant_id, shipping_days, addedQuanitity) {
    data = {
      id: cvariant_id,
      quantity: addedQuanitity,
      properties: {
        " ‎ ": shipping_days,
      }
      
    }
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(response) { 
        //console.log('our response', response);
        
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
           	 quantity: addedQuanitity
       	   }
        }));
      },
      error: function(response) {
        //console.log(response);
        //console.log(response.responseJSON.description);
        var ErrorMsg = $('<div class="product-form__status-message" style="height:auto"><p class="alert alert--error">'+response.responseJSON.description+'</p></div>');
        $(ErrorMsg).insertAfter('.product-form__payment-container');
        setTimeout(function(){ $('.product-form__status-message').remove() }, 5000);
      }
    });
  }


// $('[data-action="add-to-cart"]').click(function( ){
  
//   var qty = 1;
// var id  = $('form[action="/cart/add"]').find('[name="id"]').val();
// var properties = {
//         "delivery time": "7-8 days",
//       }
// //
// addItem(qty,id,properties,function(){
//     console.log('done');
// });

// });
  
// addItem=function(qty,id,properties,callback) {
//   var params = {quantity:qty,id:id};
//   if(properties != false){
//       params.properties = properties;
//   }
//   $.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     dataType: 'json',
//     data: params.serialize(),
//     success: function(){
//         if(typeof callback === 'function'){
//             callback();
//         }
//     },
//     error: function(){}
//   });
// }

//Example :

$('document').ready(function(){
  $('.page__tag-list li:first').insertAfter('.page__tag-list li:last');
  
  
  $(".cat_lable .has_cat").click(function(e){
    e.preventDefault();
    $(this).toggleClass("open");
    $(this).parents("li").siblings().find('.has_cat').removeClass("open");
    
    
  });
  
  
  
});




// $(document).ready(function(){
//     $(".template-article a").click(function(event){
      
// //       $(this).unbind('h');
      
//         //prevent the default action for the click event
//         event.preventDefault();
      	
      
      	

//         //get the full url - like mysitecom/index.htm#home
//         var full_url = this.href;

//         //split the url by # and get the anchor target name - home in mysitecom/index.htm#home
//         var parts = full_url.split("#");
//         var trgt = parts[1];

//         //get the top offset of the target anchor
//         var target_offset = $("#videos").offset();
      
      	
      
//         //var target_top = target_offset.top;
      
// 		console.log('target_top', target_top);
      
//       	console.log('target_offset', target_offset);
      
//       console.log('full_url', full_url);
      
//       console.log('target_offset', target_offset);
      
      
      
//       console.log('total_top', total_top);
      
//         //goto that anchor by setting the body scroll top to anchor top
//         $('html, body').animate({scrollTop:2500},'slow');
//     });
// });

$(document).ready(function(){
  $('.relposts').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:"<img class='slick-prev pull-left' src='https://cdn.shopify.com/s/files/1/0511/3964/1496/files/img_987612_85dedbe3-045c-4b0a-8ecd-86066c2b8250.png?v=1663704519' />",
    nextArrow:"<img class='slick-next pull-right' src='https://cdn.shopify.com/s/files/1/0511/3964/1496/files/img_98761_435e0571-9a0e-4785-8d1e-3984c26cfdb1.png?v=1663704520' />",
    dots: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });

  setTimeout(function(){
    $("form.product-form").attr("action", "/cart/add");
  }, 1000);

  // add anchors to all headers
  $('h2,h3,.scroll-anchor').each(function(){
      $(this).addClass('anchor-host');
      var text = $(this).text(); 
      var anchorId = text
        .replace(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, "")
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/[\s_]+/g, '-')
        .toLowerCase()
        .split('-')
        .slice(0,5)
        .join('-');
      $(this).prepend('<div id="' + anchorId + '" class="anchor"></div>');
    });
  //  end add anchors
});
